import React from 'react';
import { useEffect } from 'react';
import { useState } from 'react';
import { Alert, Col, Container, Dropdown, DropdownButton, FormCheck, FormControl, OverlayTrigger, Row, Tooltip } from 'react-bootstrap';
import DropdownMenu from 'react-bootstrap/esm/DropdownMenu';
import DropdownToggle from 'react-bootstrap/esm/DropdownToggle';
import '../../../styles/Forms.css';
import { HHIEButton } from '../../utility/HHIEButton';
import { SaveSubmitButtons } from './SaveSubmitButtons';

export function AccountForm(props) {
    const [userType, setUserType] = useState("");
    const [account, setAccount] = useState(null);
    const [participantTypes, setParticipantTypes] = useState(null);
    const [loading, setLoading] = useState(true);
    const [legalName, setLegalName] = useState("");
    const [npi, setNpi] = useState("");
    const [npiPassStat, setNpiPassStat] = useState("");
    const [npiPassComment, setNpiPassComment] = useState("");
    const [dba, setDba] = useState("");
    const [deptName, setDeptName] = useState("");
    const [participantType, setParticipantType] = useState("");
    const [otherParticipantType, setOtherParticipantType] = useState("");
    const [phone, setPhone] = useState("");
    const [address, setAddress] = useState("");
    const [city, setCity] = useState("");
    const [state, setState] = useState("Hawaii");
    const [zip, setZip] = useState("");
    const [shippingSame, setShippingSame] = useState(false);
    const [shippingAddress, setShippingAddress] = useState("");
    const [shippingCity, setShippingCity] = useState("");
    const [shippingState, setShippingState] = useState("Hawaii");
    const [shippingZip, setShippingZip] = useState("");
    const [chr, setChr] = useState(false);
    const [dsm, setDsm] = useState(false);
    const [referrals, setReferrals] = useState(false);
    const [notify, setNotify] = useState(false);
    const [saving, setSaving] = useState(false);
    const [savedMessage, setSavedMessage] = useState(null)

    const stateDrops = [
        { name: "Alabama" }, { name: "Alaska" }, { name: "Arizona" }, { name: "Arkansas" }, { name: "California" }, { name: "Colorado" }, { name: "Connecticut" }, { name: "Delaware" }, { name: "Florida" }, { name: "Georgia" }, { name: "Hawaii" }, { name: "Idaho" }, { name: "Illinois" },
        { name: "Indiana" }, { name: "Iowa" }, { name: "Kansas" }, { name: "Kentucky" }, { name: "Louisiana" }, { name: "Maine" }, { name: "Maryland" }, { name: "Massachusetts" }, { name: "Michigan" }, { name: "Misissippi" }, { name: "Missouri" }, { name: "Montana" }, { name: "Nebraska" },
        { name: "Nevada" }, { name: "New Hampshire" }, { name: "New Jersey" }, { name: "New Mexico" }, { name: "New York" }, { name: "North Carolina" }, { name: "North Dakota" }, { name: "Ohio" }, { name: "Oklahoma" }, { name: "Oregon" }, { name: "Pennsylvania" }, { name: "Rhode Island" },
        { name: "South Carolina" }, { name: "South Dakota" }, { name: "Tennessee" }, { name: "Texas" }, { name: "Utah" }, { name: "Vermont" }, { name: "Virginia" }, { name: "Washington" }, { name: "West Virginia" }, { name: "Wisconsin" }, { name: "Wyoming" }
    ];

    useEffect(() => {
        const user = JSON.parse(sessionStorage.getItem("user"));
        setUserType((user.isPOCUser) ? "POCUser" : "HHIEUser");
        const acct = JSON.parse(sessionStorage.getItem("account"));
        setAccount(acct);
        if (acct.legalName) setLegalName(acct.legalName);
        if (acct.npi) setNpi(acct.npi);
        if (acct.dba) setDba(acct.dba);
        if (acct.departmentName) setDeptName(acct.departmentName);
        if (acct.participantType) setParticipantType(acct.participantType);
        if (acct.phone) setPhone(acct.phone);
        if (acct.location.street) setAddress(acct.location.street);
        if (acct.location.city) setCity(acct.location.city);
        if (acct.location.state) setState(acct.location.state);
        if (acct.location.zipCode) setZip(acct.location.zipCode);
        if (acct.shippingAddress.street && acct.location.street && acct.shippingAddress.street === acct.location.street) {
            setShippingSame(true);
        }
        if (acct.shippingAddress.street) setShippingAddress(acct.shippingAddress.street);
        if (acct.shippingAddress.city) setShippingCity(acct.shippingAddress.city);
        if (acct.shippingAddress.state) setShippingState(acct.shippingAddress.state);
        if (acct.shippingAddress.zipCode) setShippingZip(acct.shippingAddress.zipCode);
        if (acct.participantType) setParticipantType(acct.participantType);
        if (acct.registrationType && acct.registrationType !== "") {
            var services = acct.registrationType.split(";");
            for (var i = 0; i < services.length; i++) {
                if (services[i] === "CHR") {
                    setChr(true);
                }
                else if (services[i] === "DSM") {
                    setDsm(true);
                }
                else if (services[i] === "Referrals") {
                    setReferrals(true);
                }
                else if (services[i] === "Notify") {
                    setNotify(true);
                }
            }
        }
        else {
            setChr(acct.chr);
            setDsm(acct.dsm);
            setReferrals(acct.referrals);
            setNotify(acct.notify);
        }
        setLoading(false);

        fetch('api/Registration/getParticipantTypes')
            .then((response) => {
                response.json()
                    .then((json) => {
                        if (json.errors !== null && json.errors !== "") alert(json.errors)
                        setParticipantTypes(json.message);
                    })
                    .catch((error) => {
                        console.log("json error: " + error);
                    })
            })
            .catch((error) => {
                console.log("Response error: " + error);
            });
    }, [props]);

    useEffect(() => {
        if (npi !== "" && npi.length === 10) {
            fetch('api/Registration/GetAccountData/' + npi)
                .then((response) => {
                    response.json()
                        .then((json) => {
                            if (json.errors !== null && json.errors !== "") alert(json.errors)
                            fillDataBasedOnNPI(json.message);
                            setState(json.message.location.state !== null ? json.message.location.state : state);
                        })
                        .catch((error) => {
                            console.log("json error: " + error);
                        })
                })
                .catch((error) => {
                    console.log("Response error: " + error);
                });
        }
    }, [npi, loading])

    const fillDataBasedOnNPI = (npiAcct) => {
        setLegalName((legalName === "" && npiAcct.legalName) ? npiAcct.legalName : legalName);
        setPhone((phone === "" && npiAcct.phone) ? npiAcct.phone : phone);
        setNpiPassStat(npiAcct.passStatus.npiPassStatus);
        setNpiPassComment(npiAcct.passStatus.npiComment);
        setAddress((address === "" && npiAcct.location.street) ? npiAcct.location.street : address);
        setCity((city === "" && npiAcct.location.city) ? npiAcct.location.city : city);
        setState((state === "" && npiAcct.location.state) ? npiAcct.location.state : state);
        setZip((zip === "" && npiAcct.location.zipCode) ? npiAcct.location.zipCode : zip);

    }

    const assignData = () => {
        const formData = new FormData();
        formData.append("createdDate", account.createdDate)
        formData.append("sfId", account.id);
        formData.append("legalName", legalName);
        formData.append("deptName", deptName);
        formData.append("npi", npi);
        formData.append("dba", dba);
        formData.append("participantType", !participantType.includes("Other") ? participantType : otherParticipantType);
        formData.append("phone", phone);
        formData.append("address", address);
        formData.append("city", city);
        formData.append("state", state);
        formData.append("zip", zip);
        formData.append("chr", chr);
        formData.append("dsm", dsm);
        formData.append("referrals", referrals);
        formData.append("notify", notify);
        formData.append("status",account.status)
        if (shippingSame) {
            formData.append("shippingAddress", address);
            formData.append("shippingCity", city);
            formData.append("shippingState", state);
            formData.append("shippingZip", zip);
        }
        else {
            formData.append("shippingAddress", shippingAddress);
            formData.append("shippingCity", shippingCity);
            formData.append("shippingState", shippingState);
            formData.append("shippingZip", shippingZip);
        }
        return formData;
    }

    const save = (leave) => {
        setSaving(true);
        setSavedMessage(null);
        const formData = assignData();
        const requestOptions = {
            method: 'POST',
            body: formData
        }
        fetch('api/registration/saveAccount', requestOptions)
            .then((response) => {
                response.json()
                    .then((text) => {
                        if (text.errors !== null && text.errors !== "") alert(text.errors)
                        setSaving(false);
                        setSavedMessage(text.message);
                        if (leave === "leave") window.location.href = "/registration-dashboard";
                    })
            })
            .catch((error) => {
                console.log("Response error: " + error);
                window.location.href = "/registration-dashboard";
            });
    }

    const abletoSubmit = () => {
        var result;
        if (legalName === ""
            || participantType === ""
            || participantType === "None"
            || (participantType.includes("Other") && (!otherParticipantType || otherParticipantType == ""))
            || !phone
            || phone.length < 10
            || address === ""
            || city === ""
            || state === ""
            || !zip
            || zip.length < 5
            || (npi && npi.length < 10 && npi.length > 0)
            || npiPassStat === "FAIL"
            || (!shippingSame
                && (!shippingAddress 
                || shippingAddress === ""
                || !shippingCity
                || shippingCity === ""
                || !shippingState 
                || shippingState === ""
                || !shippingZip
                || (shippingZip && shippingZip.length < 5)
            )))
            result =false;
        else result = true;
        return result;
    }

    const submit = () => {
        setSaving(true);
        setSavedMessage(null);
        const formData = assignData();
        const requestOptions = {
            method: 'POST',
            body: formData
        }
        fetch('api/registration/submitAccount', requestOptions)
            .then((response) => {
                response.json()
                    .then((text) => {
                        if (text.errors !== null && text.errors !== "") alert(text.errors)
                        setSavedMessage(text.message);
                        setSaving(false);
                        if (text.message.includes("Success")) {
                            window.location.href = "/registration-dashboard"
                        }
                    })
            })
            .catch((error) => {
                console.log("Response error: " + error);
            });
    }

    return (
        <>
            {!loading ?
                <Container style={{ padding: "15px" }}>
                    <Row>
                        <Col>
                            <div className="d-flex justify-content-end">
                                <HHIEButton
                                    variant="outline-primary"
                                    size="sm"
                                    onClick={() => {
                                        window.location.href = "/registration-dashboard"
                                    }}
                                    title="Return to Dashboard"
                                />
                            </div>
                        </Col>
                    </Row>
                    <br />
                    <h2 style={{ textAlign: "center" }}>Account Form</h2>
                    <Row style={{ padding: "6px" }}>
                            <Col className="d-flex justify-content-start" sm={8} style={(!legalName || legalName === "") ? { color: "red" } : {}}>
                                <div style={{ paddingRight: "5px" }}>Legal Organization Name*</div>
                                <FormControl
                                    required
                                    id="legal-name"
                                    isInvalid={(legalName === "" || legalName === null)}
                                    placeholder="Legal organization Name"
                                    aria-label="Legal Organization Name"
                                    aria-describedby="organization-name"
                                    defaultValue={(legalName !== null && legalName !== "") ? legalName : undefined}
                                    readOnly
                                />
                            </Col>
                        <OverlayTrigger
                            placement="bottom"
                            delay={{ show: 250, hide: 400 }}
                            overlay={<Tooltip id="npi-tip">Not required, but will autofill organization address information </Tooltip>}
                        >
                            <Col className="d-flex justify-content-end">
                                <div style={{ paddingRight: "5px" }}>Business NPI</div>
                                <FormControl
                                    id="business-npi"
                                    placeholder="Business NPI"
                                    maxLength="10"
                                    aria-label="Business NPI"
                                    aria-describedby="business-npi"
                                    defaultValue={npi}
                                    onChange={(e) => { setNpi(e.target.value); setNpiPassStat(""); setNpiPassComment(""); }}
                                    onKeyPress={(e) => { if (!(e.key >= "0" && e.key <= "9") || (e.keyCode === 8)) e.preventDefault() }}
                                />
                            </Col>
                        </OverlayTrigger>
                    </Row>
                    {(account !== null && npi !== "" && npiPassStat === "FAIL") ?
                        <Row>
                            <Col></Col>
                            <Col className="d-flex justify-content-end">
                                <Alert variant="danger">{npiPassComment}
                                </Alert>
                            </Col>
                        </Row> :
                        <></>}
                    <Row style={{ padding: "4px" }}>
                            <Col className="d-flex justify-content-start">
                                <div style={{ paddingRight: "5px" }}>Doing Business As</div>
                                <FormControl
                                    id="dba"
                                    placeholder="Doing Business As"
                                    aria-label="Doing BUsiness As"
                                    aria-describedby="dba"
                                    defaultValue={dba}
                                    readOnly
                                />
                            </Col>
                        <OverlayTrigger
                            placement="top"
                            delay={{ show: 250, hide: 400 }}
                            overlay={<Tooltip id="p-type-tip">Organization doesn't match any of these options? choose "Other Third-Party Recipient of PHI" and enter type in the box that appears</Tooltip>}
                        >
                            <Col className="d-flex justify-content-end" style={(!participantType || participantType === "" || participantType === "None") ? { color: "red" } : {}}>
                                <div>Participant Type*</div>
                                <Dropdown
                                    required
                                    id="p-type-dropdown"
                                    style={{ paddingLeft: "4px" }}
                                >
                                    <DropdownToggle
                                        className="table-button"
                                        id="dropdown-p-type-button"
                                        variant={(!participantType || participantType == "" || participantType == "None")?"outline-danger":"light"}
                                        style={{ textAllign: "right", paddingBottom: "5" }}
                                    >{participantType}</DropdownToggle>
                                    <DropdownMenu
                                        style={{ maxHeight: "200px", overflowY: "scroll" }}
                                    >
                                        {(participantTypes !== null) ? participantTypes.map((value, index) => (
                                            <Dropdown.Item
                                                key={index}
                                                eventKey={value}
                                                type="radio"
                                                value={value}
                                                active={participantType === value}
                                                onSelect={(e) => { setParticipantType(e); setOtherParticipantType(""); }}
                                            >
                                                {value}
                                            </Dropdown.Item>
                                        ))
                                            : <></>}
                                    </DropdownMenu>
                                </Dropdown>
                            </Col>
                        </OverlayTrigger>
                    </Row>
                    <Row style={{ padding: "6px" }}>
                            <Col className="d-flex justify-content-start">
                                <div style={{ paddingRight: "5px" }}>Department Name</div>
                                <FormControl
                                    id="dept-name"
                                    placeholder="Department Name"
                                    aria-label="Department Name"
                                    aria-describedby="dept-name"
                                    defaultValue={deptName}
                                    readOnly
                                />
                            </Col>
                        {(participantType !== null && participantType.includes("Other")) ?
                            <OverlayTrigger
                                placement="bottom"
                                delay={{ show: 250, hide: 400 }}
                                overlay={<Tooltip id="dba-tip">Please specify</Tooltip>}
                            >
                                <Col className="d-flex justify-content-end">
                                    <div style={{ paddingRight: "5px" }}>Participant Type</div>
                                    <FormControl
                                        id="participant-type"
                                        required={participantType.includes("Other")}
                                        isInvalid={otherParticipantType === "" || otherParticipantType === null}
                                        placeholder="Participant Type"
                                        aria-label="Participant Type"
                                        aria-describedby="participant-type"
                                        onChange={(e) => { setOtherParticipantType(e.target.value); }}
                                    />
                                </Col>
                            </OverlayTrigger>
                            : <Col></Col>}
                    </Row>
                    <Row style={{ padding: "6px" }}>
                        <Col className="d-flex justify-content-start" style={(!phone || phone === "" || phone.length < 10) ? { color: "red" } : {}}>
                            <div style={{ paddingRight: "5px" }}>Phone Number*</div>
                            <FormControl
                                id="phone"
                                placeholder="Phone Number"
                                aria-label="Phone Number"
                                aria-describedby="phone-number"
                                defaultValue={(phone !== null) ? phone : undefined}
                                onChange={(e) => { setPhone(e.target.value); }}
                                onKeyPress={(e) => { if (!(e.key >= "0" && e.key <= "9") || (e.keyCode === 8)) e.preventDefault() }}
                            />
                        </Col>
                    </Row>
                    <Row>
                        <Col className="d-flex justify-content-start" ><strong>Billing Address</strong></Col>
                        <Col className="d-flex justify-content-end" style={(!address || address === "") ? { color: "red" } : {}}>
                            <div style={{ paddingRight: "5px" }}>Street Address*</div>
                            <FormControl
                                id="billing-address"
                                placeholder="Address"
                                aria-label="Address"
                                aria-describedby="address"
                                defaultValue={(address !== null) ? address : undefined}
                                onChange={(e) => { setAddress(e.target.value); }}
                            />
                        </Col>
                    </Row>
                    <Row style={{ padding: "6px" }}>
                        <Col className="d-flex justify-content-start" style={(!city || city === "") ? { color: "red" } : {}}>
                            <div style={{ paddingRight: "5px" }}>City*</div>
                            <FormControl
                                id="billing-city"
                                placeholder="City"
                                aria-label="City"
                                aria-describedby="city"
                                defaultValue={(city !== null) ? city : undefined}
                                onChange={(e) => { setCity(e.target.value); }}
                            />
                        </Col>
                        <Col className="d-flex justify-content-center" style={(!state || state === "") ? { color: "red" } : {}}>
                            <div>State*</div>
                            <DropdownButton
                                className="table-button"
                                id="dropdown-billing-state-button"
                                style={{ paddingLeft: "4px" }}
                                title={state}
                                variant="light"
                            >
                                {stateDrops.map((value, index) => (
                                    <Dropdown.Item
                                        key={index}
                                        eventKey={value.name}
                                        type="radio"
                                        value={value.name}
                                        active={state === value.name}
                                        onSelect={(e) => { setState(e); }}
                                    >
                                        {value.name}
                                    </Dropdown.Item>
                                ))}
                            </DropdownButton>
                        </Col>
                        <Col className="d-flex justify-content-end" style={(!zip || zip === "") ? { color: "red" } : {}}>
                            <div style={{ paddingRight: "5px" }}>Zip Code*</div>
                            <FormControl
                                id="billing-zip"
                                placeholder="Zip Code"
                                aria-label="Zip Code"
                                aria-describedby="zip-code"
                                defaultValue={(zip !== null) ? zip : undefined}
                                onChange={(e) => { setZip(e.target.value); }}
                                onKeyPress={(e) => { if (!(e.key >= "0" && e.key <= "9") || (e.keyCode === 8)) e.preventDefault() }}
                            />
                        </Col>
                    </Row>
                    <Row style={{ padding: "6px" }}>
                        <Col className="d-flex justify-content-center">
                            <FormCheck
                                id="shipping-check"
                                label="Shipping the same as Billing Address?"
                                name="shipping"
                                type="checkbox"
                                defaultChecked={shippingSame}
                                onChange={(e) => { setShippingSame(e.target.checked) }}
                            />
                        </Col>
                    </Row>
                    {!shippingSame ?
                        <>
                            <Row>
                                <Col className="d-flex justify-content-start" ><strong>Shipping Address</strong></Col>
                                <Col className="d-flex justify-content-end" style={(!shippingAddress || shippingAddress === "") ? { color: "red" } : {}}>
                                    <div style={{ paddingRight: "5px" }}>Street Address*</div>
                                    <FormControl
                                        id="shipping-address"
                                        placeholder="Address"
                                        aria-label="Address"
                                        aria-describedby="address"
                                        defaultValue={(shippingAddress !== null) ? shippingAddress : undefined}
                                        onChange={(e) => { setShippingAddress(e.target.value); }}
                                    />
                                </Col>
                            </Row>
                            <Row style={{ padding: "6px" }}>
                                <Col className="d-flex justify-content-start" style={(!shippingCity || shippingCity === "") ? { color: "red" } : {}}>
                                    <div style={{ paddingRight: "5px" }}>City*</div>
                                    <FormControl
                                        id="shipping-city"
                                        placeholder="City"
                                        aria-label="City"
                                        aria-describedby="city"
                                        defaultValue={(shippingCity !== null) ? shippingCity : undefined}
                                        onChange={(e) => { setShippingCity(e.target.value); }}
                                    />
                                </Col>
                                <Col className="d-flex justify-content-center" style={(!shippingState || shippingState === "") ? { color: "red" } : {}}>
                                    <div>State*</div>
                                    <DropdownButton
                                        id="dropdown-shipping-state-button"
                                        className="table-button"
                                        style={{ paddingLeft: "4px" }}
                                        title={shippingState}
                                        variant="light"
                                    >
                                        {stateDrops.map((value, index) => (
                                            <Dropdown.Item
                                                key={index}
                                                eventKey={value.name}
                                                type="radio"
                                                value={value.name}
                                                active={shippingState === value.name}
                                                onSelect={(e) => { setShippingState(e); }}
                                            >
                                                {value.name}
                                            </Dropdown.Item>
                                        ))}
                                    </DropdownButton>
                                </Col>
                                <Col className="d-flex justify-content-end" style={(!shippingZip || shippingZip === "") ? { color: "red" } : {}}>
                                    <div style={{ paddingRight: "5px" }}>Zip Code*</div>
                                    <FormControl
                                        id="shipping-zip"
                                        placeholder="Zip Code"
                                        aria-label="Zip Code"
                                        aria-describedby="zip-code"
                                        defaultValue={(zip !== null) ? shippingZip : undefined}
                                        onChange={(e) => { setShippingZip(e.target.value); }}
                                        onKeyPress={(e) => { if (!(e.key >= "0" && e.key <= "9") || (e.keyCode === 8)) e.preventDefault() }}
                                    />
                                </Col>
                            </Row>
                        </>
                        : <></>
                    }
                    <Row style={{ padding: "8px" }}>
                        <Col md={1} lg="auto"></Col>
                        <Col className="d-flex justify-content-center">
                            <div><strong>Services, Solutions and Access</strong></div>
                        </Col>
                        <OverlayTrigger
                            placement="bottom"
                            delay={{ show: 250, hide: 400 }}
                            overlay={<Tooltip id="chr-tip">The Community
                                Health Record is a
                                repository of
                                patient
                                information
                                submitted by
                                users of the Health
                                eNet</Tooltip>}
                        >
                            <Col className="d-flex justify-content-center">
                                <FormCheck
                                    disabled
                                    label="Community Health Record"
                                    name="access"
                                    type="checkbox"
                                    id="chr-check"
                                    defaultChecked={chr}
                                    onChange={(e) => { setChr(e.target.checked); }}
                                />
                            </Col>
                        </OverlayTrigger>
                        <OverlayTrigger
                            placement="bottom"
                            delay={{ show: 250, hide: 400 }}
                            overlay={<Tooltip id="referrals-tip">The Electronic Referrals platform
                                allows your practice to send/receive
                                referrals to/from other participants in
                                the Health eNet</Tooltip>}
                        >
                            <Col className="d-flex justify-content-center">
                                <FormCheck
                                    disabled
                                    label="Referrals"
                                    name="access"
                                    type="checkbox"
                                    id="referrals-check"
                                    defaultChecked={referrals}
                                    onChange={(e) => { setReferrals(e.target.checked); }}
                                />
                            </Col>
                        </OverlayTrigger>
                        <OverlayTrigger
                            placement="bottom"
                            delay={{ show: 250, hide: 400 }}
                            overlay={<Tooltip id="dsm-tip">Collaborate and
                                coordinate between care
                                professionals using DSM, a
                                HIPAA Compliant
                                Encrypted Secure Email
                                service</Tooltip>}
                        >
                            <Col className="d-flex justify-content-center">
                                <FormCheck
                                    disabled
                                    label="Direct Secure Messaging"
                                    name="access"
                                    type="checkbox"
                                    id="dsm-check"
                                    defaultChecked={dsm}
                                    onChange={(e) => { setDsm(e.target.checked); }}
                                />
                            </Col>
                        </OverlayTrigger>
                        <OverlayTrigger
                            placement="bottom"
                            delay={{ show: 250, hide: 400 }}
                            overlay={<Tooltip id="notify-tip">Receive
                                notifications from
                                participating
                                facilities on your
                                practice's
                                patient/member
                                cohort</Tooltip>}
                        >
                            <Col className="d-flex justify-content-center">
                                <FormCheck
                                    disabled
                                    label="Notify"
                                    name="access"
                                    type="checkbox"
                                    id="notify-check"
                                    defaultValue={notify}
                                    onChange={(e) => { setNotify(e.target.checked) }}
                                />
                            </Col>
                        </OverlayTrigger>
                        <Col md={1} lg="auto"></Col>
                    </Row>
                    {!saving && savedMessage &&
                        <Row>
                            <Col className="d-flex justify-content-center">
                                <Alert id="success-alert" variant={savedMessage.includes("Success") ? "success" : "danger"}>{savedMessage}</Alert>
                            </Col>
                        </Row>
                    }
                    <SaveSubmitButtons
                        saving={saving}
                        save={(goToHome) => { save(goToHome) }}
                        submit={() => { submit() }}
                        submitButtonExists={true}
                        saveAndNewAllowed={false}
                        disabled={!abletoSubmit()}
                    />
                </Container>
                : <>Loading</>
            }
        </>
    );
}